/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { updateFilter, resetFilters } from "../index";

export const useCampaignFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilterAction: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(updateFilter({ key, value }));

  const resetFiltersAction = () => dispatch(resetFilters());

  return {
    updateFilter: updateFilterAction,
    resetFilters: resetFiltersAction
  };
};
